var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var MessangerSvg = /* @__PURE__ */ __name(function MessangerSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M26.516 13.805c-0.317-1.989-1.223-3.725-2.531-5.068l0.002 0.002c-1.633-1.714-3.637-2.746-5.96-3.164-0.494-0.089-1-0.114-1.5-0.17-0.043 0-0.086-0.014-0.129-0.022h-0.772c-0.21 0.018-0.422 0.032-0.632 0.055-3.425 0.363-6.178 1.876-8.109 4.77-0.865 1.287-1.407 2.855-1.476 4.546l-0.001 0.018c-0.006 0.055-0.013 0.103-0.024 0.15l0.002-0.009v0.631c0.025 0.25 0.045 0.501 0.075 0.75 0.226 1.884 0.977 3.538 2.194 4.986 0.475 0.564 0.998 1.062 1.571 1.497l0.024 0.017c0.064 0.045 0.105 0.118 0.105 0.201 0 0.008-0 0.015-0.001 0.023l0-0.001q0 1.724 0 3.449v0.154c0.068-0.035 0.117-0.059 0.164-0.085q1.65-0.905 3.299-1.813c0.059-0.035 0.13-0.056 0.206-0.056 0.042 0 0.082 0.006 0.12 0.018l-0.003-0.001c3.261 0.791 6.326 0.341 9.131-1.528 2.047-1.364 3.432-3.241 4.062-5.637 0.128-0.488 0.177-0.999 0.263-1.499 0.008-0.042 0.015-0.085 0.023-0.127v-1.351c-0.036-0.248-0.064-0.493-0.102-0.736zM17.068 18.625c-0.074-0.078-0.145-0.15-0.213-0.224q-1.207-1.287-2.413-2.576c-0.022-0.035-0.060-0.058-0.104-0.058-0.028 0-0.053 0.009-0.074 0.025l0-0q-2.027 1.113-4.055 2.22l-1.045 0.572-0.015-0.021 5.742-6.095 1.166 1.213q0.767 0.799 1.532 1.601c0.022 0.028 0.055 0.046 0.093 0.046 0.030 0 0.057-0.011 0.078-0.030l-0 0q2.464-1.367 4.928-2.73c0.033-0.022 0.073-0.035 0.116-0.037h0z"
  }));
}, "MessangerSvg");
var MessangerIcon = /* @__PURE__ */ __name(function MessangerIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: MessangerSvg
  }, props));
}, "MessangerIcon");
export {
  MessangerIcon
};
